import { useHistory } from "react-router-dom";
import { CART } from "../constants/routeConstants";
import { message } from "antd";

interface UseCart {
addToCart: () => void;
}

export const useCart = (perfume: any): UseCart => {
  const history = useHistory();

  const addToCart = (): void => {
    if (!perfume || !perfume.id) {
      console.error("❌ ERROR: addToCart called with invalid perfume:", perfume);
      message.error("Unable to add product to cart.");
      return;
    }

    const perfumeId = Number(perfume.id);
    const minQty = Number(perfume.minQuantity || 1);
    const maxQty = Number(perfume.maxQuantity || 999999);

    console.log("👉 Adding perfume:", perfumeId, "minQty:", minQty, "maxQty:", maxQty);

    let stored = localStorage.getItem("perfumes");
    let cart: Map<number, number> = stored ? new Map(JSON.parse(stored)) : new Map();

    // Remove invalid entries
    cart = new Map(
      Array.from(cart.entries()).filter(([id]) => id !== null && !isNaN(id))
    );

    if (cart.has(perfumeId)) {
      const existing = cart.get(perfumeId)!;

      // Normal increment
      if (existing + 1 > maxQty) {
        message.error(`Maximum quantity allowed is ${maxQty}`);
        cart.set(perfumeId, maxQty);
      } else {
        cart.set(perfumeId, existing + 1);
      }

    } else {
      // FIRST TIME add → set EXACTLY minQuantity (NO +1)
      cart.set(perfumeId, minQty);
    }

    localStorage.setItem("perfumes", JSON.stringify(Array.from(cart.entries())));

    console.log("🛒 Updated Cart Map:", Array.from(cart.entries()));

    // Redirect to cart
    setTimeout(() => history.push(CART), 50);
  };

  return { addToCart };
};
